export default "__VITE_ASSET__c182a8f3__"